import styled from 'styled-components';
import { FaStar } from 'react-icons/fa';

export const StyledRatio = styled.input`
    display: none;
`;

export const StaledFaStar = styled(FaStar)`
    cursor: pointer;
    transition: color 200ms;
`;
